import { CreateCollection } from "../../collections/CreateCollection"

type WazKBAddProps = {

}

export const WazKBAdd = ({} : WazKBAddProps) => {

    return (
        <CreateCollection />
    )
}